import { useStationGroups } from '@app/core/stations/hooks/useStationGroups';
import { InfoM } from '@app/modules/audit/modules/aod/screens/aod-rule-view/components/InfoM';
import { getLanguage, Station } from '@mi-front/core';
import { Box, Chip, Grid } from '@mui/material';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { FormattedMessage } from 'react-intl';
import { StationType } from './StationType';

interface Props {
  readonly station: Station;
}

export function StationInfo(p: Props) {
  const { station } = p;
  const groupsQuery = useStationGroups(station.id);

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InfoM label={<FormattedMessage id="common.text.name" defaultMessage="Nombre" />}>
            {station.name}
          </InfoM>
        </Grid>
        {station.type && (
          <Grid item xs={12}>
            <InfoM label={<FormattedMessage id="common.text.type" defaultMessage="Tipo" />}>
              <StationType type={station.type} />
            </InfoM>
          </Grid>
        )}
        <Grid item xs={12}>
          <InfoM
            label={<FormattedMessage id="common.text.timezone" defaultMessage="Zona horaria" />}
          >
            {station.timezone}
          </InfoM>
        </Grid>
        <Grid item xs={12}>
          <InfoM label={<FormattedMessage id="common.text.language" defaultMessage="Idioma" />}>
            {getLanguage(station.language)?.name}
          </InfoM>
        </Grid>
        <Grid item xs={12}>
          <InfoM
            label={
              <FormattedMessage id="admin.stations.viewScreen.groups" defaultMessage="Grupos" />
            }
          >
            <QueryView inline query={groupsQuery}>
              {(groups) => {
                if (!groups || groups.length === 0) {
                  return (
                    <FormattedMessage
                      id="admin.stations.viewScreen.noGroups"
                      defaultMessage="No se encontraron grupos"
                    />
                  );
                }

                return (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {groups.map((group) => (
                      <Chip key={group.id} label={group.name} variant="outlined" />
                    ))}
                  </Box>
                );
              }}
            </QueryView>
          </InfoM>
        </Grid>
      </Grid>
    </Box>
  );
}
